import React, { useState, useContext } from "react";
import { Link as RouterLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { authContext } from '../provider/Auth'
import { LinkButton } from '../components/LinkButton';


const LogoutButton = () => {
  const { logout } = useContext(authContext);

  return <Button onClick={logout}>Logout</Button>
}

const LoginButton = () => {
  const { login } = useContext(authContext);

  return <Button onClick={login}>Logout</Button>
}

const LoginLinkButton = () => {
  return <LinkButton activeColor="primary" to="/admin/login">Login</LinkButton>
}

export const LoginLogoutButton = () => {
  const { state } = useContext(authContext);
  const { loggedIn } = state
  return loggedIn?<LogoutButton/>:<LoginLinkButton/>
}